"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyType = void 0;
/**
 * The PropertyType object provides a set of constants for property types.
 *
 * These constants are based on the RESO PropertyType dictionary.
 * See: {@link https://ddwiki.reso.org/display/DDW20/PropertyType+Lookups}
 */
exports.PropertyType = Object.freeze({
    /** The property type of the listing is Business Opportunity. The property type can be references as a class or a field within a single class structure. */
    BusinessOpportunity: "Business Opportunity",
    /** The property type of the listing is Commercial Lease. The property type can be references as a class or a field within a single class structure. */
    CommercialLease: "Commercial Lease",
    /** The property type of the listing is Commercial Sale. The property type can be references as a class or a field within a single class structure. */
    CommercialSale: "Commercial Sale",
    /** The property type of the listing is Farm. The property type can be references as a class or a field within a single class structure. */
    Farm: "Farm",
    /** The property type of the listing is Land. The property type can be references as a class or a field within a single class structure. */
    Land: "Land",
    /** The property type of the listing is Manufactured in Park. The property type can be references as a class or a field within a single class structure */
    ManufacturedInPark: "Manufactured In Park",
    /** The property type of the listing is Residential. The property type can be references as a class or a field within a single class structure. */
    Residential: "Residential",
    /** The property type of the listing is Residential Income. The property type can be references as a class or a field within a single class structure. */
    ResidentialIncome: "Residential Income",
    /** The property type of the listing is Residential Lease. The property type can be references as a class or a field within a single class structure. */
    ResidentialLease: "Residential Lease",
    /** Other is a catch-all for any property type that is not explicitly listed in the RESO PropertyType dictionary */
    Other: "Other",
    /** Other is a catch-all for any property type that is not explicitly listed in the RESO PropertyType dictionary */
    OtherLease: "Other Lease"
});
//# sourceMappingURL=property_type.js.map